import { render, staticRenderFns } from "./PcRedEnvelope.vue?vue&type=template&id=d4a128b6&"
import script from "./PcRedEnvelope.vue?vue&type=script&lang=js&"
export * from "./PcRedEnvelope.vue?vue&type=script&lang=js&"
import style0 from "./PcRedEnvelope.vue?vue&type=style&index=0&id=d4a128b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports